import { render } from "./ArticleEditor.vue?vue&type=template&id=741b989c&scoped=true"
import script from "./ArticleEditor.vue?vue&type=script&lang=js"
export * from "./ArticleEditor.vue?vue&type=script&lang=js"

import "./ArticleEditor.vue?vue&type=style&index=0&id=741b989c&lang=scss&scoped=true"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741b989c"]])

export default __exports__